import { HttpClient } from '@angular/common/http';
import { inject, Injectable, NgModule } from '@angular/core';

import { getStorageItem } from '@bbraun/helpex/src/lib/utils';
import {
  provideTransloco,
  Translation,
  TranslocoLoader,
  TranslocoModule,
} from '@jsverse/transloco';

import { AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE } from '@/app/shared/util-common/languages.contants';
import { SESSION_STORAGE } from '@/app/shared/util-common/storage/session-storage.constants';

@Injectable()
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: AVAILABLE_LANGUAGES,
        defaultLang: getStorageItem(SESSION_STORAGE.LANGUAGE) ?? DEFAULT_LANGUAGE,
        fallbackLang: DEFAULT_LANGUAGE,
        reRenderOnLangChange: true,
        prodMode: true,
        missingHandler: {
          useFallbackTranslation: true,
        },
      },
      loader: TranslocoHttpLoader,
    }),
  ],
})
export class TranslocoRootModule {}
